module.exports = __webpack_public_path__ + "static/media/smartphone.fbb071f2.jpg";